import React from "react";
import { usePermissions } from "../../contexts/PermissionContext";

// Props for map-specific access control
interface MapAccessControlProps {
  children: React.ReactNode;
  brandId?: number;
  branchId?: number;
  fallback?: React.ReactNode;
}

// Map access control component - implements ticket 3 requirements
export const MapAccessControl: React.FC<MapAccessControlProps> = ({
  children,
  brandId,
  branchId,
  fallback,
}) => {
  const { hasPermission, hasBranchAccess, hasBrandAccess } = usePermissions();

  // Check if user has basic map access
  const hasMapAccess = () => {
    if (hasPermission("map:view_full") || hasPermission("map:view_partial")) {
      if (brandId && !hasBrandAccess(brandId)) return false;
      if (branchId && !hasBranchAccess(branchId)) return false;
      return true;
    }
    return false;
  };

  if (!hasMapAccess()) {
    return (
      fallback || (
        <div className="p-4 text-center text-gray-500">
          <p>No tienes permisos para acceder al mapa</p>
        </div>
      )
    );
  }

  return <>{children}</>;
};
